//@flow
import * as React from 'react'
import LineItemsForm from './LineItemsForm';
import AddLineItemForm from './AddLineItemForm';
import MaterialPaperWrap from '../../components/common/MaterialPaperWrap'
import type { LineItemsContainer$Props} from '../generic/flowTypes'

const LineItemsContainer=(props:LineItemsContainer$Props)=>{
    let children = <LineItemsForm jwt={props.jwt} taskAcceptedInfoId={props.taskAcceptedInfoId} />

    if (props.isTriggerAddLineItem){
        children = <AddLineItemForm jwt={props.jwt} taskAcceptedInfoId={props.taskAcceptedInfoId} />
    }

    return (
        <div className='row'>
           <div className='col-sm'>
             <MaterialPaperWrap>
                {children}
             </MaterialPaperWrap>
           </div>
        </div>
    )
}

export default LineItemsContainer


// WEBPACK FOOTER //
// ./src/views/projectAthena/LineItemsContainer.js